/**
 * ACT2-1124 (D18): a sibling workspace lists warehouse accounts of other RudderStack workspaces only for the
 * workspaces in the readable list of Settings › General. While that list is empty, this notice points there.
 */
import { Link } from 'react-router-dom';

import { Callout } from '@/_shared/components/ui/callout';
import { useWorkspace } from '@/_shared/contexts/WorkspaceContext';

export function ReadableWorkspacesNotice({ className }: { className?: string }): React.ReactElement {
  const { wp } = useWorkspace();
  return (
    <Callout variant="info" className={className}>
      To connect warehouse accounts of other RudderStack workspaces, add the workspaces in{' '}
      <Link to={wp('/settings')} className="font-medium underline">
        Settings › General
      </Link>
      .
    </Callout>
  );
}
